export var Event;
(function (Event) {
    Event["Escape"] = "escape";
    Event["Refresh"] = "refresh";
    Event["RequestUpdate"] = "request-update";
    Event["Toast"] = "toast";
    Event["Wakeup"] = "wakeup";
})(Event || (Event = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["INFO"] = "is-info";
    NotificationType["SUCCESS"] = "is-success";
    NotificationType["WARNING"] = "is-warning";
    NotificationType["DANGER"] = "is-danger";
})(NotificationType || (NotificationType = {}));
export var Storage;
(function (Storage) {
    Storage["Page"] = "page";
    Storage["Token"] = "token";
    Storage["User"] = "user";
})(Storage || (Storage = {}));
//# sourceMappingURL=enums.js.map